import React from 'react';
import { Container, Text, Button, Spacer } from "@nextui-org/react";
import { useNavigate } from 'react-router-dom';

interface ErrorPageProps {
  title?: string;
  description?: string;
  code?: number;
  onRetry?: () => void;
}

const ErrorPage: React.FC<ErrorPageProps> = ({
  title = "Oops!",
  description = "Something went wrong.",
  code,
  onRetry
}) => {
  const navigate = useNavigate();

  return (
    <Container display="flex" direction="column" alignItems="center" justify="center" css={{ minHeight: '80vh' }}>
      {code && <Text h1 size={100} css={{ textGradient: "45deg, $red600 -20%, $pink600 50%" }}>{code}</Text>}
      <Text h2 color="error">{title}</Text>
      <Spacer y={1} />
      <Text size={18} css={{ textAlign: 'center', maxWidth: '600px' }}>{description}</Text>
      <Spacer y={2} />
      <div style={{ display: 'flex', gap: '1rem' }}>
        {onRetry && (
          <Button onPress={onRetry}>
            Retry
          </Button>
        )}
        <Button ghost onPress={() => navigate(0)}>
          Go Home
        </Button>
      </div>
    </Container>
  );
};

export default ErrorPage;
